module.exports = __webpack_public_path__ + "img/check.49023e51.png";